module.exports = __webpack_public_path__ + "img/btn_TOEIC_practise_off.06f9a62f.png";